export default "__VITE_ASSET__vylbLkZ0__"